// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","menuTooltip":"HashMenu_menuTooltip__jLnaG","visible":"HashMenu_visible__3dBl8"};